import './ChatBubble.css';
import React from 'react';
import { Tooltip } from 'antd';
import { sanitizeHTML } from '../utils';
import { isHTML } from '../pages/agentSms/utils';

interface ChatBubbleProps {
  message: string;
  isOwnMessage: boolean;
  timestamp: string;
  timestampTooltip?: string;
  status?: string;
  onClick?: () => void;
  speaker?: string;
  variant?: 'agent' | 'other';
}

const ChatBubble = ({
  message,
  isOwnMessage,
  timestamp,
  timestampTooltip,
  status,
  onClick,
  speaker,
  variant,
}: ChatBubbleProps) => {
  return (
    <div
      className={`chat-bubble ${isOwnMessage ? 'own-message' : 'other-message'} ${variant ? `variant-${variant}` : ''}`}
      onClick={onClick}
    >
      {speaker && (
        <div style={{ fontWeight: 600, marginBottom: 2, fontSize: 13 }}>
          {speaker}
        </div>
      )}
      <div
        style={{
          textAlign: 'left',
          whiteSpace: 'pre-wrap',
          fontFamily: 'inherit',
        }}
      >
        {isHTML(message) ? (
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(message),
            }}
          />
        ) : (
          message
        )}
      </div>
      <div className="chat-timestamp">
        {timestampTooltip ? (
          <Tooltip title={timestampTooltip}>
            <span>{timestamp.split('+')[0]}</span>
          </Tooltip>
        ) : (
          timestamp.split('+')[0]
        )}
      </div>
      {status && <div className="chat-timestamp">{status}</div>}
    </div>
  );
};

export default ChatBubble;
